import { QuotaDTO } from '@/business-logic/relay-service'

/**
 * Check if the user has enough gas to send a relayer transaction
 *
 * @param relayerQuota
 * @param gasLimit
 * @returns true/false if user has enough gas on his account
 */
export const hasRelayerGasQuota = (
  relayerQuota?: QuotaDTO,
  gasLimit?: number | string
) => {
  if (typeof gasLimit === 'string') {
    gasLimit = Number(gasLimit)
  }
  return (relayerQuota?.quotaRemaining || 0) > (gasLimit || 0)
}
